
import './footer.css'

export default function Footer(){
   return(
     <div className='footer'>
        <img src='logo_white_cropped.png' alt='weather logo'></img>
        <h4>Made by PJV</h4>

     </div>
   )

}
